/**
 * Any time we want to send a user down an earmarked path, use a URL that has
 * cf?=name-of-earmark-here. When you later want to refer back to it, it will
 * have been recorded here initially.
 *
 * cf = "came from"
 */
export const cameFrom = new URLSearchParams(window.location.search).get('cf');
